import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const positionStyles = (placement, offset) => {
  const [offsetX, offsetY] = offset;
  return {
    "top-left": {
      top: offsetY,
      left: offsetX,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%"
    },
    "top-right": {
      top: offsetY,
      right: offsetX,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%"
    },
    "bottom-left": {
      bottom: offsetY,
      left: offsetX,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%"
    },
    "bottom-right": {
      bottom: offsetY,
      right: offsetX,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%"
    }
  }[placement];
};
const StyledPinComponent = styled(Box)(({ placement, pinOffset }) => __spreadValues({
  position: "absolute"
}, positionStyles(placement, pinOffset)));
const Pin = (_a) => {
  var _b = _a, { children, component, placement = "top-right", pinOffset = [0, 0] } = _b, props = __objRest(_b, ["children", "component", "placement", "pinOffset"]);
  return /* @__PURE__ */ React.createElement(Box, __spreadValues({
    position: "relative",
    display: "inline-flex"
  }, props), children, /* @__PURE__ */ React.createElement(StyledPinComponent, {
    placement,
    pinOffset
  }, component));
};

export { Pin };
//# sourceMappingURL=Pin.es.js.map
